export const resolveSettingByVehicleType = (setting, vehicleType) => {
  const resolvedSetting = setting[vehicleType.toLowerCase()]
  return resolvedSetting !== undefined ? resolvedSetting : setting.default
}

export default {
  resolveSettingByVehicleType
}
